"use strict";

exports = module.exports = {
  // List of user roles
  userRoles: ["guest", "user", "admin"],
  env: process.env.NODE_ENV||'development'
};



//////////////////
// WEBPACK FOOTER
// ./server/config/environment/shared.js
// module id = 32
// module chunks = 0